<app-folder-dialog-content dialogTitle="folder_selector.edit_folder"
                           submitBtnText="folder_selector.submit"
                           [dialogRef]="dialogRef"
                           subtitleIcon="edit"
                           [subtitle]="data.folder.getFullPathToStr()"
                           (onApply)="onApply($event)"></app-folder-dialog-content>
